module.exports = __webpack_public_path__ + "dentalcleaning-mobile___1vV4S.svg";